import { useQuery } from '@tanstack/react-query';
import { ApiError, apiRequestAmbEtag } from './client';

/**
 * Carrega un recurs juntament amb el seu ETag perquè el formulari que l'edita pugui enviar
 * `If-Match` amb la versió que l'usuari ha vist (i no una de nova obtinguda just abans del PUT,
 * que amagaria els canvis concurrents). `staleTime: 0` + `refetchOnWindowFocus: false`: es torna
 * a llegir en obrir el formulari però no es refresca sota els peus de l'usuari mentre edita.
 */
export function useAmbEtag<T>(ruta: string | null | undefined) {
  return useQuery({
    queryKey: ['etag', ruta],
    queryFn: () => apiRequestAmbEtag<T>(ruta as string),
    enabled: ruta != null,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });
}

/** Cert si l'error és un conflicte de versió (412 Precondition Failed). */
export function esConflicteVersio(e: unknown): boolean {
  return e instanceof ApiError && e.status === 412;
}
